<section class="cards__section" [ngClass]="sectionClass">
  <div class="cards__section-container">
    @if (title && !isFirstSection) {
      <h2 class="cards__title" [innerHTML]="title"></h2>
    }
    @if (title && isFirstSection) {
      <h1 class="cards__title" [innerHTML]="title"></h1>
    }
    @if (titleImgSrc) {
      <img
        class="cards__title-image"
        [src]="titleImgSrc"
        [alt]="titleImgAltText"
        sizes="(max-width: 136px) 100vw, 136px"
      />
    }
    @if (subtitle) {
      <p class="cards__subtitle" [innerHTML]="subtitle"></p>
    }
  </div>

  @if (numbers) {
    <div class="cards__section-container cards__card-number__container">
      @for (card of contents; track card; let cardIteration = $index) {
        <div class="cards__card-number-desktop">
          <div class="cards__card-divider"></div>
          <div class="cards__card-number">
            <span>{{ cardIteration + 1 }}</span>
          </div>
        </div>
      }
    </div>
  }
  <div class="cards__section-container cards__container">
    @for (card of contents; track card; let cardIteration = $index) {
      <div class="cards__card-wrapper">
        @if (numbers) {
          <div class="cards__card-number-mobile">
            <div class="cards__card-divider"></div>
            <div class="cards__card-number">
              <span>{{ cardIteration + 1 }}</span>
            </div>
          </div>
        }

        <div class="cards__card">
          <div class="cards__card__content">
            @if (card.imgSrc) {
              <div class="card-basic-section__card__img">
                @if (!pageConfigService.isSafari()) {
                  <picture>
                    <img
                      [src]="card.imgSrc"
                      [alt]="card.imgAltText"
                      style="width: auto"
                    />
                  </picture>
                }
                @if (pageConfigService.isSafari()) {
                  <img
                    [src]="card.imgSrc"
                    [alt]="card.imgAltText"
                    style="width: auto"
                  />
                }
              </div>
            }
            @if (card.title) {
              <h3
                class="card-basic-section__card__title"
                [innerHTML]="getSafeHTML(card.title)"
              ></h3>
            }
            @if (card.description) {
              <div
                class="card-basic-section__card__description"
                [innerHTML]="getSafeHTML(card.description)"
              ></div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</section>
